import { render, staticRenderFns } from "./ProvinceCityAreaWithoutTownView.vue?vue&type=template&id=b8d65820&scoped=true&"
import script from "./ProvinceCityAreaWithoutTownView.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaWithoutTownView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d65820",
  null
  
)

export default component.exports